import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ace99ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block-content t-block-teal l-block-spacing" }
const _hoisted_2 = { class: "l-contained" }
const _hoisted_3 = { class: "heading-group" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<span class=\"w100\" data-v-2ace99ca>월</span><span class=\"w200\" data-v-2ace99ca>간</span><span class=\"w300\" data-v-2ace99ca>제</span><span class=\"w400\" data-v-2ace99ca>임</span><span class=\"w500\" data-v-2ace99ca>쓰</span>", 5)
const _hoisted_10 = [
  _hoisted_5
]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<span class=\"w100\" data-v-2ace99ca>M</span><span class=\"w200\" data-v-2ace99ca>o</span><span class=\"w300\" data-v-2ace99ca>n</span><span class=\"w400\" data-v-2ace99ca>t</span><span class=\"w500\" data-v-2ace99ca>h</span><span class=\"w600\" data-v-2ace99ca>l</span><span class=\"w700\" data-v-2ace99ca>y</span>", 7)
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w800" }, "James", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "indie hacking", -1))
const _hoisted_21 = { class: "timeline-list" }
const _hoisted_22 = { class: "copyright" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "w100" }, "Monthly James Co., Ltd", -1))
const _hoisted_24 = { class: "w600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VerticalTimeLineItemView = _resolveComponent("VerticalTimeLineItemView")!
  const _component_RiCopyrightFill = _resolveComponent("RiCopyrightFill")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("h2", null, [
          (_ctx.currentLocale == 'ko')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_10))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createTextVNode(),
                _hoisted_19
              ]))
        ]),
        _hoisted_20
      ]),
      _createElementVNode("ul", _hoisted_21, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _createVNode(_component_VerticalTimeLineItemView, {
              project: (project as IProject)
            }, null, 8, ["project"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("p", _hoisted_24, [
          _createTextVNode(" Copyright "),
          _createVNode(_component_RiCopyrightFill, { class: "icon-copy" }),
          _createTextVNode(" Monthly James Co., Ltd All Rights Reserved ")
        ])
      ])
    ])
  ]))
}